var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gala:add",
    clipPath: "url(#clip0_490_4931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99304 2.70389C5.80447 2.70389 2.40897 6.0994 2.40897 10.288C2.40897 14.4765 5.80447 17.872 9.99304 17.872C14.1816 17.872 17.5771 14.4765 17.5771 10.288C17.5771 6.0994 14.1816 2.70389 9.99304 2.70389ZM1.24219 10.288C1.24219 5.455 5.16008 1.53711 9.99304 1.53711C14.826 1.53711 18.7439 5.455 18.7439 10.288C18.7439 15.1209 14.826 19.0388 9.99304 19.0388C5.16008 19.0388 1.24219 15.1209 1.24219 10.288ZM5.90931 10.288C5.90931 9.96577 6.1705 9.70457 6.4927 9.70457H9.40965V6.78762C9.40965 6.46542 9.67084 6.20423 9.99304 6.20423C10.3152 6.20423 10.5764 6.46542 10.5764 6.78762V9.70457H13.4934C13.8156 9.70457 14.0768 9.96577 14.0768 10.288C14.0768 10.6102 13.8156 10.8714 13.4934 10.8714H10.5764V13.7883C10.5764 14.1105 10.3152 14.3717 9.99304 14.3717C9.67084 14.3717 9.40965 14.1105 9.40965 13.7883V10.8714H6.4927C6.1705 10.8714 5.90931 10.6102 5.90931 10.288Z",
    fill: "#2828F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_4931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6685,
    height: 18.6685,
    fill: "white",
    transform: "translate(0.660156 0.953613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.981600cfca8d992d572b08609568bcbb.svg";
export { ForwardRef as ReactComponent };